import { type ChangeEvent, type ReactNode, useCallback } from 'react'
import { Icon } from '@/components/Icon'
import styles from './TableSearchbar.module.css'

interface TableSearchbarProps {
  searchText: string
  isDisabled?: boolean
  onSearchTextChange: (value: string) => void
  children?: ReactNode
  placeholder?: string
}

/**
 * The TableSearchbar.
 */
export function TableSearchbar({
  searchText,
  isDisabled,
  children,
  onSearchTextChange,
  placeholder,
}: TableSearchbarProps) {
  const change = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onSearchTextChange(e.target.value),
    [onSearchTextChange],
  )
  return (
    <div>
      <div className={styles.mainMenu}>
        <div className={styles.searchInputContainer}>
          <div className={styles.searchInputIcon}>
            <Icon name="search" />
          </div>
          <input
            className={styles.searchInput}
            placeholder={placeholder ?? 'Search'}
            type="search"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            value={searchText}
            onChange={change}
            disabled={isDisabled}
          />
        </div>
        <div className={styles.menuItems}>{children}</div>
      </div>
    </div>
  )
}

interface TableSearchbarMenuItemProps {
  children?: ReactNode
}

/**
 * Table Searchbar Menu Item
 */
export function TableSearchbarMenuItem({
  children,
}: TableSearchbarMenuItemProps) {
  return <div className={styles.menuItem}>{children}</div>
}
